export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6738.88bab507.jpg";